
let DateTimeUtils = {

    formatDate: function(isoDate) {
        let ticks = Date.parse(isoDate);
        let dt = new Date(ticks);
        if (!dt || (!dt instanceof Date))
            return '';
        return dt.getMonth() +1 + '/' + dt.getDate() + '/' + dt.getYear().toString().substr(-2);
    },


    formatLongDate: function(isoDate) {
        let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        let ticks = Date.parse(isoDate);
        let dt = new Date(ticks);
        if (!dt || (!dt instanceof Date))
            return '';
        let dayName = days[dt.getDay()];
        return dayName + " " + (dt.getMonth() +1) + '/' + dt.getDate() + "/" + dt.getYear().toString().substr(-2);
    },

    formatTime: function(isoDate) {
        let ticks = Date.parse(isoDate);
        let dt = new Date(ticks);
        if (!dt || (!dt instanceof Date))
            return '';
        if (process.env.BROWSER)
            return dt.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'});
        return dt.toLocaleTimeString();

    }
};

exports.Utils = DateTimeUtils;